import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { Constants } from '../constants/constants';
import { AdminRoleService } from '../service/admin-role.service';
import { ApiService } from '../service/api.service';
import { AuthenticationService } from '../service/authentication.service';
import { EnvService } from '../service/env.service';
import { ToastService } from '../service/toast.service';
import { UtilService } from '../service/util.service';
import { SearchDataService } from '../service/search-data.service';
import { PhoneValidatorDirective } from '../directives/phone-validator.directive';
import { PhoneFormatterDirective } from '../directives/phone-formatter.directive';
// import { SearchCountryField, PhoneNumberFormat, CountryISO } from 'ngx-intl-tel-input';
// import { NgxIntlTelInputService } from '../service/ngx-intl-tel-input-service.service';
// import { PhoneNumberFormat } from 'google-libphonenumber';

@Component({
  selector: 'app-admin-roles',
  templateUrl: './admin-roles.component.html',
  styleUrls: ['./admin-roles.component.scss']
})
export class AdminRolesComponent implements OnInit, OnDestroy, AfterViewInit {

  admins: any;
  adminFormData: any = { "role": "ROLE_ACCOUNT_ADMIN" };
  selectedAdmins: Array<string> = new Array();
  selectedAdminsCount = 0;
  deletedAdminsCount = 0;
  deleteAdminsFailed: Array<string> = new Array();
  accountCategory: string;
  accountType: string;
  loggedInUserId: any;
  @ViewChild('addAdminForm', { static: true }) public addAdminForm: NgForm;
  userRoles: any = [];
  // isd;
  countryList: any[];
  account: any;
  // preferredCountries: CountryISO[] = Constants.PREFERRED_COUNTRIES;

  /* countryFormatter = (x: { name: string }) => x.name;
  searchCountry = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? []
        : this.countryList.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1))
    );
    
  selectedIsdDetails: any;
  isdFormatter = (x: { isd: string }) => x.isd;
  searchIsd = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? [] : this.countryList.filter(v => (v.name.toLowerCase().indexOf(term.toLowerCase()) > -1 || v.isd.toLowerCase().indexOf(term.toLowerCase()) > -1)))
    );
  
  phoneLength = 0; */

  searchedUserList: Array<any>;
  showSearchResult: boolean = false;
  selectedSearchItemForView: string;
  isViewUserDetail: boolean = false;

  // SearchCountryField = SearchCountryField;
  // PhoneNumberFormat = PhoneNumberFormat;
  selectedCountryISO: any;
  selectedPhone: any;

  // countries = Constants.COUNTRIES;
  // selectedCountryIsd: String = null;
  // selectedUserPhone: String = null;
	
  adminPhone: string = null;
  adminCountryIsotwo: any;
  allCountryList: any[];
  
  @ViewChild(PhoneValidatorDirective) phoneValidator!: PhoneValidatorDirective;
  @ViewChild(PhoneFormatterDirective) phoneFormatter!: PhoneFormatterDirective;
  @ViewChild('phoneElement', { static: true, read: ElementRef }) phoneInput!: ElementRef; 

  constructor(
    private apiService: ApiService,
    public authService: AuthenticationService,
    private utilService: UtilService,
    private toast: ToastService,
    private adminRoleService: AdminRoleService,
    private env: EnvService,
    private searchService: SearchDataService,
    // private ngxIntlTelInputService: NgxIntlTelInputService
  ) {
    this.account = this.apiService.accountDetail;
    this.countryList = this.utilService.getCountryList(this.env.REGION);
    this.initDefaultCountryIsd();
  }
  
  ngAfterViewInit() {
    this.triggerPhoneInputChange(this.adminPhone, this.adminCountryIsotwo);
  }

  ngOnInit() {
    this.accountCategory = this.apiService.accountDetail.category;
    this.accountType = this.apiService.accountDetail.type;
    console.log("** Loading user list this.utilService.isSearchFromUserList: ", this.utilService.isSearchFromUserList);
    
    if (this.utilService.isSearchFromUserList) {
      console.log("DO search");
      this.utilService.isSearchFromUserList = false;
      this.searchService.searchForData(this.searchService.searchKey);
    } else {
      this.getAllUsers();
    }

    this.userRoles = this.adminRoleService.adminRoles;
    
    if (this.isDealerOrCorporateAccountAgent(this.userRoles)) {
      this.userRoles.splice(this.userRoles.indexOf('ROLE_FMC_AGENT'), 1);
    }
    
    if (!this.authService.isShowDeveloperAccess(this.account.name)) {
      var index = this.userRoles.indexOf('ROLE_ACCOUNT_DEVELOPER');
      if (index !== -1) {
        this.userRoles.splice(index, 1);
      }
    }

    if (this.accountCategory == Constants.CORPORATE_CUSTOMER) {
      var index = this.userRoles.indexOf('ROLE_ACCOUNT_DEVELOPER');
      if (index !== -1) {
        this.userRoles.splice(index, 1);
      }
    }
    
    if (!this.authService.accountData.isShowDeveloperUser) {
      var index = this.userRoles.indexOf('ROLE_ACCOUNT_DEVELOPER');
      if (index !== -1) {
        this.userRoles.splice(index, 1);
      }
    }

    console.log("user roles: ", this.userRoles);

    // this.getAccountUserRoles();
    this.loggedInUserId = this.authService.loggedInUser.userId;

    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
  }

  ngOnDestroy(): void {
    this.searchService.searchedData.next(null);
    this.searchService.searchedDataFromApi = null;
    // this.adminRoleService.adminRoles = [];
  }

  private processSearchResult() {
    this.searchedUserList = this.searchService.getSearchedDataForType(Constants.USERS_ENTITY);
    if (this.searchedUserList && this.searchedUserList.length > 0) {
      this.showSearchResult = true;
      this.selectedSearchItemForView = null;
      this.closeUserDetailClicked(null);
    } else {
      this.showSearchResult = false;
    }
  }

  closeUserDetailClicked(data) {
    this.isViewUserDetail = false;
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  getAllUsers() {
    this.utilService.showSpinner();
    this.apiService.getAllUsers().then((data) => {
      this.utilService.hideSpinner();
      this.admins = this.filterDrivers(data);
      console.log("admin data ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAllUsers();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  addUsersByRole(requestPayload: any) {
    console.log("Adding user with data : ", requestPayload);
    this.utilService.showSpinner();
    this.apiService.addUsersByRole(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("User created successfully");
      document.getElementById("closeInviteAdmin").click();
      this.resetAddAdminForm();
      this.getAllUsers();
      console.log("add admin response ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addUsersByRole(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onAdminSelected(id: string) {
    console.log("admin id::", id);
    let itemIndex = this.selectedAdmins.indexOf(id);
    if (itemIndex !== -1) {
      this.selectedAdmins.splice(itemIndex, 1);
    } else {
      this.selectedAdmins.push(id);
    }
    console.log("selected admins::", this.selectedAdmins);
  }

  onDeleteAdmins() {
    console.log("Received the request for delet admins::", this.selectedAdmins);
    if (this.selectedAdmins.length > 0) {
      this.selectedAdminsCount = this.selectedAdmins.length;
      this.selectedAdmins.forEach(userId => {
        this.deleteUser(userId);
      });
    } else {
      this.toast.showWarning("No user selected");
    }
  }

  onCreateAdmin(form: NgForm) {
    console.log("admin form data::", this.adminFormData);
    // this.adminFormData.adminPhone = this.selectedPhone && this.ngxIntlTelInputService.removeNonNumeric(this.selectedPhone.number) || null;

    if (form.valid) {
      if (this.adminFormData.role) {
        // this.isd = this.selectedIsdDetails.isd;

        const requestPayload = [{
          "roles": [this.adminFormData.role],
          "name": this.adminFormData.name,
          "username": this.adminFormData.adminEmail,
          // TODO: handle isd for multiple countries
          // "phone": this.adminFormData.adminPhone,
          // "phone": this.selectedUserPhone,
          "phone": this.adminPhone.replace(/\D/g, ''),
          // "isd": this.isd,
          // "isd": this.adminFormData.isd,
          // "isd": this.selectedCountryIsd,
          "isd": this.allCountryList.find(country => country.isotwo === this.adminCountryIsotwo).isd,
          "image": this.adminFormData.image,
          // "country": this.adminFormData.country
        }]
        console.log("request Payload::", requestPayload);
        this.addUsersByRole(requestPayload);
      } else {
        this.toast.showWarning("Please select role");
      }
    }
  }

  changeuploadFleetB2BLogoClicked() {
    document.getElementById("uploadUserLogoInput").click();
  }

  uploadFleetB2BLogo(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      var extn = file.name.split('.').pop();
      console.log("extn : ", extn);
      if (!Constants.ALLOWED_IMAGE_TYPE.includes(extn.toLowerCase())) {
        this.toast.showError(Constants.IMAGE_UPLOAD_FILE_TYPE_ERROR_MESSAGE);
        return;
      }
      var fileSizeInKB = file.size / 1024;
      console.log("actual file size : ", file.size, " - fileSizeInKB : ", fileSizeInKB, " - max file size limit in kb : ", Constants.IMAGE_UPLOAD_MAX_SIZE_KB);
      if (fileSizeInKB > Constants.IMAGE_UPLOAD_MAX_SIZE_KB) {
        this.toast.showError(Constants.IMAGE_UPLOAD_FILE_SIZE_ERROR_MESSAGE);
        return;
      }
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('folder', 'user/' + this.apiService.accountDetail.id);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.adminFormData['image'] = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadFleetB2BLogo(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toast.showError(error.error.message);
          else this.toast.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  }

  navigateToDetailPage(user) {
    console.log("Selected user : ", user);
    this.utilService.selectedAccountUser = user;
    this.utilService.isOpenFromSearch = false;
  }

  resetAddAdminForm() {
    this.adminFormData = {
      "role": "ROLE_ACCOUNT_ADMIN"
    };
    this.addAdminForm.resetForm(this.adminFormData);
    setTimeout(() => {
      this.initDefaultCountryIsd();
      this.triggerPhoneInputChange(this.adminPhone, this.adminCountryIsotwo);
    }, 500);
  }

  getAccountUserRoles() {
    var requestPayload = {
      "type": "B2B"
    };
    this.utilService.showSpinner();
    this.apiService.getRoles(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("User roles ::", data);
      this.userRoles = data;
      this.adminRoleService.adminRoles = data;
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountUserRoles();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  deleteUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deleteAccountUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.deletedAdminsCount += 1;
      this.resetAdminsDeleted();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deleteUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        this.deleteAdminsFailed.push(userId);
        this.resetAdminsDeleted();
        // if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        // else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetAdminsDeleted() {
    if (this.selectedAdminsCount == (this.deletedAdminsCount + this.deleteAdminsFailed.length)) {

      if (this.deleteAdminsFailed.length == 0) {
        this.toast.showSuccess("Users Deleted successfully");
      } else {
        this.toast.showError("Delete failed for users : " + this.deleteAdminsFailed.length);
      }
      this.getAllUsers();
      this.resetDeleteUser();
    }
  }


  resetDeleteUser() {
    this.selectedAdmins = [];
    this.selectedAdminsCount = 0;
    this.deletedAdminsCount = 0;
    this.deleteAdminsFailed = [];
  }

  cancelDeleteUser() {
    this.resetDeleteUser();
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  filterDrivers(data) {
    var users = new Array();
    data.forEach(el => {
      if (!this.isRoleExist(el.roles, "ROLE_FMC_DRIVER") && !this.isDealerOrCorporateAccountAgent(el.roles)) {
        users.push(el);
      }
    });
    return users;
  }

  isDealerOrCorporateAccountAgent(roles) {
    if (this.isRoleExist(roles, "ROLE_FMC_AGENT") && this.doesAccountSupportsDongle()) {
      return true;
    } else {
      return false;
    }
  }

  isRoleExist(roles, role) {
    var isExist = false;
    for (var i = 0; i < roles.length; i++) {
      if (role == roles[i]) {
        isExist = true;
        break;
      }
    }
    return isExist;
  }

  doesAccountSupportsDongle() {
    if (this.utilService.doesAccountSupportsDongle(this.accountCategory)) {
      return true;
    }
    return false;
  }
  
  isdSelected(isd) {
  }  

  initDefaultCountryIsd() {
    // this.adminFormData.country = this.account.contactPoints.addresses[0].country
    
    // if (!this.adminFormData.country)
    //   this.adminFormData.country = Constants.DEFAULT_LOCALES[0].country;

    // this.updateIsd(this.account.country);

    // let selectedCountryData = Constants.COUNTRIES.find(country => country.name.toLowerCase() === this.adminFormData.country.toLowerCase());
    // this.selectedCountryIsd = selectedCountryData ? selectedCountryData.dialCode : null;

    /* setTimeout(() => {
      this.selectedCountryISO = this.ngxIntlTelInputService.getCountryISO(this.adminFormData.country);
    }, 0); */
    // this.adminFormData.isd = this.getDefultIsd();

    /* this.adminCountryIsotwo = this.allCountryList.find(country => country.name === this.adminFormData.country).isotwo;
    this.triggerPhoneInputChange(this.adminPhone, this.adminCountryIsotwo); */

    this.allCountryList = this.utilService.getCountryList();
    this.adminCountryIsotwo = this.allCountryList.find(country => country.name === this.account.contactPoints.addresses[0].country).isotwo;
  } 
  
  /* getDefultIsd() {
    let filterdCountryData = this.ngxIntlTelInputService.filterCountriesByName(this.adminFormData.country);
    if (!filterdCountryData) {
      filterdCountryData = this.ngxIntlTelInputService.filterCountriesByName(this.utilService.getDefaultCountry());
    }
    if (filterdCountryData) {
      return '+' + this.ngxIntlTelInputService.getCountryName(filterdCountryData[2]);
    } else {
      return null;
    }
  } */

  /* onCountrySelected(event) {
    this.updateIsd(event);
  }
    
  updateIsd(selectedCountry) {
    if (!selectedCountry)
      selectedCountry = Constants.DEFAULT_LOCALES[0].country;

    console.log("countrylist: ", this.countryList);  

    if (!this.adminFormData.adminPhone) {
      let selectedCountryData = this.countryList.filter(country => country.name == selectedCountry)[0];
      
      if (selectedCountryData) {
        this.selectedIsdDetails = selectedCountryData;
        this.onIsdSelected(selectedCountryData);
      }
    }
  }
  
  onIsdSelected(event) {
    this.phoneLength = event.phoneLength;
    this.isd = event.isd;
  } */

  onCountryChange(event: any) {
    // this.adminFormData.country = this.ngxIntlTelInputService.getCountryName(event.name);
    this.adminFormData.isd = "+" + event.dialCode;
  }
  
  countryUpdated(event: any) {
    this.triggerPhoneInputChange(this.adminPhone, event);
  }

  triggerPhoneInputChange(phone: string, isotwo: string) {
    this.phoneValidator.countryCode = isotwo;
    this.phoneFormatter.countryCode = isotwo;
    this.phoneInput.nativeElement.value = phone;
    const event = new Event('input', { bubbles: true });
    this.phoneInput.nativeElement.dispatchEvent(event);
  }

  getadminCountryIsotwoIsd() {
    let adminCountryIsotwoData = this.allCountryList.find(country => country.isotwo === this.adminCountryIsotwo);
    return adminCountryIsotwoData ? adminCountryIsotwoData.isd : null;
  }
}

